const Navigation = ((($) => {

  let lastId;
  let topMenu;
  let topMenuHeight;
  let menuItems;
  let scrollItems;
  let item;
  let href;
  let offsetTop;
  let fromTop;
  let cur;
  let id;

  function init() {
    // Cache selectors
    lastId,
    topMenu = $('#Navigation'),
    topMenuHeight = topMenu.outerHeight()+35,
    // All list items
    menuItems = topMenu.find('a'),
    // Anchors corresponding to menu items
    scrollItems = menuItems.map(function() {
      item = $($(this).attr('href'));
      if (item.length) {
        return item;
      }
    });

    // Bind click handler to menu items
    // so we can get a fancy scroll animation
    menuItems.click(function(e) {
      $('body').removeClass('overflow-h');
      href = $(this).attr('href'),
      offsetTop = href === '#' ? 0 : $(href).offset().top-20;
      $('html, body').stop().animate({
        scrollTop: offsetTop
      }, 300);
      e.preventDefault();
    });

    // Bind to scroll
    $(window).scroll(function() {
      // Get container scroll position
      fromTop = $(this).scrollTop()+topMenuHeight;

      // Get id of current scroll item
      cur = scrollItems.map(function() {
        if ($(this).offset().top < fromTop)
          return this;
      });
      // Get the id of the current element
      cur = cur[cur.length-1];
      id = cur && cur.length ? cur[0].id : '';

      if (lastId !== id) {
        lastId = id;
        // Set/remove active class
        menuItems
          .parent().removeClass('active')
          .end().filter('[href="#'+id+'"]').parent().addClass('active');
      }
    });

    $('.mobile-nav-btn').on('click', function() {
      $(this).toggleClass('is-active');
      $('body').toggleClass('overflow-h');
      $('.Header__wr').toggleClass('show');
      return false;
    });
    if($(window).width() <= 768) {
      $('.Menu a').on('click', function() {
        $(this);

        $('.Header__wr').removeClass('show');
        $('.mobile-nav-btn').removeClass('is-active');
      });
    }
  }
  return {
    init,
  };

}))(jQuery);

export default Navigation;


// WEBPACK FOOTER //
// ./src/static/js/modules/navigation.js